import * as React from 'react'

import {
  ItemActions as ItemActionsPrimitive,
  ItemCaption as ItemCaptionPrimitive,
  ItemContent as ItemContentPrimitive,
  ItemDescription as ItemDescriptionPrimitive,
  ItemFooter as ItemFooterPrimitive,
  ItemGroup as ItemGroupPrimitive,
  ItemHeader as ItemHeaderPrimitive,
  ItemMedia as ItemMediaPrimitive,
  Item as ItemPrimitive,
  ItemSeparator as ItemSeparatorPrimitive,
  ItemTitle as ItemTitlePrimitive,
} from '@ps/ds/ui/item'

// Re-export primitives as extendable components
export const Item = ItemPrimitive
export const ItemMedia = ItemMediaPrimitive
export const ItemContent = ItemContentPrimitive
export const ItemActions = ItemActionsPrimitive
export const ItemGroup = ItemGroupPrimitive
export const ItemSeparator = ItemSeparatorPrimitive
export const ItemTitle = ItemTitlePrimitive
export const ItemCaption = ItemCaptionPrimitive
export const ItemDescription = ItemDescriptionPrimitive
export const ItemHeader = ItemHeaderPrimitive
export const ItemFooter = ItemFooterPrimitive

// Export types for extension
export type ItemProps = React.ComponentProps<typeof ItemPrimitive>
export type ItemMediaProps = React.ComponentProps<typeof ItemMediaPrimitive>
export type ItemContentProps = React.ComponentProps<typeof ItemContentPrimitive>
export type ItemActionsProps = React.ComponentProps<typeof ItemActionsPrimitive>
export type ItemGroupProps = React.ComponentProps<typeof ItemGroupPrimitive>
export type ItemSeparatorProps = React.ComponentProps<typeof ItemSeparatorPrimitive>
export type ItemTitleProps = React.ComponentProps<typeof ItemTitlePrimitive>
export type ItemCaptionProps = React.ComponentProps<typeof ItemCaptionPrimitive>
export type ItemDescriptionProps = React.ComponentProps<typeof ItemDescriptionPrimitive>
export type ItemHeaderProps = React.ComponentProps<typeof ItemHeaderPrimitive>
export type ItemFooterProps = React.ComponentProps<typeof ItemFooterPrimitive>
